import React, { useEffect, useRef, useState } from "react";
import completionStyle from "./completion.module.css";
import courseVideo from "./videos.module.css";
import { DownloadIcon } from "../../svg";
import FooterComponent from "../../component/FooterComponent";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCertificate } from "../redux/courseSlice";
import { calculateActualPrice } from "../helper/Calculation";
import html2canvas from "html2canvas";
import QRCode from "react-qr-code";
import ErrorPage from "../../component/ErrorPage";
import { unwrapResult } from "@reduxjs/toolkit";
import { CircularProgress } from "@mui/material";
import api from "../helper/Api";

const CourseCompletion = () => {
  const { id, studentId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const certificateRef = useRef();
  const [signatureBase64, setSignatureBase64] = useState('');
  // State to track window dimensions
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });


  const percentage = windowSize.width / 10

  const [loading, setLoading] = useState(false);

  const { certificateData } = useSelector((state) => state.courses);

  useEffect(() => {
    // Handler to update window size
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures effect runs only on mount and unmount


  useEffect(() => {
    fetchCert();
  }, [dispatch, id]);

  const fetchCert = async () => {
    try {
      setLoading(true);
      const result = await dispatch(getCertificate({ id, studentId }));
      await unwrapResult(result);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (certificateData?.adminSignature) {
      convertImageToBase64(certificateData.adminSignature);
    }
  }, [certificateData]);

  const convertImageToBase64 = async (imageUrl) => {
    try {
      const { data, status } = await api.getImgBase64({
        url: imageUrl
      });
      if (status === 200) {
        setSignatureBase64(data.base64);
      }
    } catch (error) {
      console.error("Error converting image to base64:", error);
    }
  };

  const formatDate = (date) => {
    const dateFromMongoDB = new Date(date);
    const formattedDate = dateFromMongoDB.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short", // This will give abbreviated month names (e.g., Dec)
      year: "numeric",
    });
    return formattedDate;
  };

  const url = `https://courses.kingster.edu.in/courses/Courses/CourseDetails/CoursesVideos/CourseCompletion/${id}/${studentId}`;

  const generateQRCode = () => {
    const canvas = document.getElementById("canvas");
    QRCode.toCanvas(
      canvas,
      url,
      {
        width: 10,
        color: {
          dark: "#000000", // QR code color (foreground)
          light: "inherit", // Background color
        },
      },
      (error) => {
        if (error) console.error(error);
      }
    );
  };

  //   useEffect(() => {
  //     generateQRCode();
  //   }, [url]);
  //package changed

  useEffect(() => {
    const canvas = document.getElementById("canvas");
    if (canvas && url) {
      QRCode.toCanvas(
        canvas,
        url,
        {
          width: 50,
          color: {
            dark: "#000000",
            light: "inherit",
          },
        },
        (error) => {
          if (error) console.error("QR Code generation error:", error);
        }
      );
    }
  }, [url]);

  const handleDownload = async () => {
    try {
      const input = certificateRef.current;
      if (!input) return;

      // Convert HTML to Canvas with high resolution
      const canvas = await html2canvas(input, {
        useCORS: true,
        allowTaint: true, // Allow cross-origin images
        scale: 10, // Increase scale for higher resolution
        backgroundColor: null, // Make background transparent if needed
        logging: false, // Disable logs for performance
        // width: input.scrollWidth, // Set width properly
        // height: input.scrollHeight, // Set height properly
        // windowWidth: input.scrollWidth,
        // windowHeight: input.scrollHeight,
      });

      // Trim excess white space
      const imgData = canvas.toDataURL("image/png", 1.0); // 1.0 means highest quality

      // Create a download link
      const link = document.createElement("a");
      link.href = imgData;
      link.download = "certificate.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("An error occurred during the PNG download:", error);
    }
  };

  return (
    <div>
      <div
        className={courseVideo.courseVideo}
        style={{ marginLeft: 20 }}
        onClick={() => navigate("/courses/Courses")}
      >
        Back to list
      </div>

      {
        loading ? <div style={{ width: "100vw", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <CircularProgress size={44} />
        </div>
          :

          certificateData && Object.keys(certificateData).length > 0 ? (
            <>
              <div className={completionStyle.courseCompletion}>
                <div className={completionStyle.mainContainer}>
                  <div
                    className={completionStyle.courseCertification}
                    id="pdf-content"
                    ref={certificateRef}
                  >
                    <img className={completionStyle.certImg} src="/certificateTemplate.jpg" alt="" />
                    <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>
                      {/* <div style={{ position: "relative", width: "100%", height: "100%" }}> */}
                      <div className={completionStyle.qrSvg} style={{ position: "absolute", padding: 10, top: 10, right: 10 }}>
                        {/* <canvas id="canvas"></canvas> */}
                        <QRCode
                          size={70}
                          value={url}
                        // viewBox={`0 0 256 256`}
                        // color="#000"
                        />
                      </div>
                      <div
                        className={completionStyle.certificateDetails}
                      >
                        <div style={{ fontSize: "18px", color: "#000000", textAlign: "center" }}>
                          Kingster Education proudly presents this Certificate of Achievement to
                        </div>
                        <div className={completionStyle.studentName}  >
                          {certificateData?.studentId?.name}{" "}
                        </div>

                        <div className={completionStyle.congratsMsg}>
                          in recognition of their outstanding dedication and successful completion of our comprehensive {certificateData?.courseId?.title}, showcasing an exemplary understanding and mastery of contemporary digital commerce practices and innovative online business solutions.
                        </div>
                      </div>
                      <div className={completionStyle.imgStyle}>
                        <img
                          src={signatureBase64}
                          alt="signature"
                          id="signature-image"
                        />
                        <h4 style={{ color: "#000000", fontSize: "16px", fontWeight: "bold" }}>DIRECTOR</h4>
                      </div>

                    </div>
                  </div>

                  <div className={completionStyle.descriptionText}>
                    This certificate above verifies that
                    {certificateData?.studentId?.name} successfully completed the
                    course <a href="">{certificateData?.courseId?.title}</a> on{" "}
                    {formatDate(certificateData?.completionDate)} as taught by{" "}
                    {certificateData?.courseId?.createdBy[0]?.name} on kingster. The
                    certificate indicates the entire course was completed as
                    validated by the student. The course duration represents the
                    total video hours of the course at time of most recent
                    completion.
                  </div>
                </div>
                <div className={completionStyle.rightSideContainer}>
                  <div className={completionStyle.courseDetails}>
                    <div className={completionStyle.jsStyle}>
                      <div className={completionStyle.jsTextStyle}>JS</div>
                      <div>
                        <p className={completionStyle.reciepent}>
                          Certificate Recipient:
                        </p>
                        <p className={completionStyle.reciepentName}>
                          {certificateData?.studentId?.name}
                        </p>
                      </div>
                    </div>
                    <div className={completionStyle.courseDetailsText}>
                      Course details
                    </div>
                    <img
                      src={certificateData?.courseId?.thumbnail[0]}
                      className={completionStyle.imageView}
                      alt="Thumbnail"
                    />
                    <div className={completionStyle.courseBy}>
                      Course by:{" "}
                      <span>{certificateData?.courseId?.createdBy[0].name}</span>
                    </div>
                    <div className={completionStyle.courseTitle}>
                      {certificateData?.courseId?.title}
                    </div>
                    <div className={completionStyle.prizeText}>
                      Rs.
                      {calculateActualPrice(
                        certificateData?.courseId?.price,
                        certificateData?.courseId?.discount
                      )}
                      : <span>{certificateData?.courseId?.price}</span>
                    </div>
                    <div className={completionStyle.lineStyle} />
                    <div className={completionStyle.courseTitle}>
                      Download this course:
                    </div>
                    <div
                      className={completionStyle.download}
                      onClick={handleDownload}
                    >
                      <DownloadIcon /> Download
                    </div>
                  </div>
                </div>
              </div>
              <FooterComponent />
            </>
          ) : (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              {/* <h2>No data found</h2> */}
              <ErrorPage />
            </div>
          )}
    </div>
  );
};

export default CourseCompletion;
